"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.global_options = exports.CTGOptions = void 0;
class CTGOptions {
    constructor(mute = false) {
        this.mute = mute;
        this.scale = 10;
    }
    static Load() {
        let jsonStr = "";
        try {
            // This can fail if localStorage is not granted.
            jsonStr = localStorage.getItem('CTG_options');
        }
        catch (e) {
            console.log("LocalStorage access denied. Options and scores will not be saved.");
        }
        try {
            const json = JSON.parse(jsonStr);
            return new CTGOptions(json['mute']);
        }
        catch (e) {
            console.log("Error parsing options: " + jsonStr);
            return new CTGOptions();
        }
    }
    save() {
        try {
            localStorage.setItem('FBD_options', JSON.stringify({
                'mute': this.mute,
            }));
        }
        catch (e) {
            console.log("LocalStorage access denied. Options and scores will not be saved.");
        }
    }
}
exports.CTGOptions = CTGOptions;
exports.global_options = CTGOptions.Load();
